module.exports = __webpack_public_path__ + "img/super_pet_detail.b7623aec.png";